// removed by extract-text-webpack-plugin
module.exports = {"padded":"src-components-Box----style-module---padded---3KvQj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/style.module.scss
// module id = 103
// module chunks = 35783957827783 114276838955818